import DataTable from 'components/ui/DataTable/data-table';
import React, { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  IEvaluationTrainee,
  useListEvaluationTraineeQuery
} from 'redux/reducers/assignmentEvalutaion';

interface IEvaluationDataTable {
  tableHeaders?: () => React.ReactNode;
  onEditClicked: (data: IEvaluationTrainee) => void;
  onDeleteClicked: (data: IEvaluationTrainee) => void;
  onViewClicked: (data: IEvaluationTrainee) => void;
  onAddQuestions: (data: IEvaluationTrainee) => void;
}

const AddTableData: FC<IEvaluationDataTable> = ({
  tableHeaders,
  onEditClicked,
  onDeleteClicked,
  onViewClicked,
  onAddQuestions
}) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { id } = useParams();
  const { data: EvaluationQueryData, isLoading } = useListEvaluationTraineeQuery(Number(id) || 0);

  const canNext = false;
  const canPrevious = false;

  const columns: any = [
    {
      Header: 'title',
      accessor: 'title'
    },
    {
      Header: ' start date time',
      accessor: 'start_date_time'
    },
    {
      Header: 'end date time',
      accessor: 'end_date_time'
    },

    {
      Header: 'passing percentage',
      accessor: 'passing_percentage'
    },
    {
      Header: 'evaluation phase',
      Cell: (data: any) => {
        return <div>{data.row.original?.evaluation_phase == 1 ? 'Pre' : 'Post'}</div>;
      }
    },
    {
      Header: 'is_active',
      Cell: (data: any) => {
        return <div>{data.row.original?.is_active == true ? 'True' : 'False'}</div>;
      }
    },

    {
      Header: '  Actions',
      Cell: (data: any) => {
        return (
          <>
            <img
              src={require('../NewEvaluation/Images/edit.png')}
              alt="edit"
              style={{ marginRight: '10px' }}
              onClick={() => onEditClicked(data.row.original)}
            />
            <img
              src={require('../NewEvaluation/Images/Vector.png')}
              alt="delete"
              onClick={() => onDeleteClicked(data.row.original.id)}
            />
            <div
              className="border cursor-pointer p-1 rounded bg-primary text-white"
              onClick={() => onAddQuestions(data.row.original)}>
              Add Questions
            </div>
          </>
        );
      }
    }
  ];

  return (
    <div className="list form-check-all">
      <DataTable
        columns={columns}
        isLoading={isLoading}
        data={
          EvaluationQueryData?.data && EvaluationQueryData?.data?.length > 0
            ? EvaluationQueryData?.data
            : []
        }
        tableHeaders={tableHeaders}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
            if (canPrevious) {
              page > 1 && setPage(page - 1);
            }
          },
          nextPage: () => {
            if (canNext) {
              setPage(page + 1);
            }
          }
        }}
      />
    </div>
  );
};

export default AddTableData;
